export default [
  {
    path: '/primeiro-acesso',
    name: 'primeiro-acesso',
    component: () => import('@/views/onboarding/OnboardingGamificado.vue'),
  },
]
